var SpriteSymbol = require("../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "clear",
  "use": "clear-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"clear\">\n    <rect width=\"16\" height=\"16\" rx=\"8\" />\n    <path d=\"M10.7344 3.625L8 6.35938L5.26562 3.625L3.625 5.26562L6.35938 8L3.625 10.7344L5.26562 12.375L8 9.64062L10.7344 12.375L12.375 10.7344L9.64062 8L12.375 5.26562L10.7344 3.625Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol